import { render, staticRenderFns } from "./IbxContentViewer.vue?vue&type=template&id=7c6a4dbe"
import script from "./IbxContentViewer.vue?vue&type=script&lang=js"
export * from "./IbxContentViewer.vue?vue&type=script&lang=js"
import style0 from "./IbxContentViewer.vue?vue&type=style&index=0&id=7c6a4dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports